import React, {
  useEffect,
  useState
} from "react";

import {
  Link,
  useNavigate
} from "react-router-dom";

import axios from "axios";

import {
  FaUserCircle,
  FaSignOutAlt
} from "react-icons/fa";

import "./VisionNavbar.css";


const VisionNavbar = ({
  active = "measure"
}) => {

  /* =====================================================
     NAVIGATE
  ===================================================== */

  const navigate = useNavigate();


  /* =====================================================
     EMAIL
  ===================================================== */

  const email =
    localStorage.getItem(
      "user_email"
    );


  /* =====================================================
     PROFILE PHOTO
  ===================================================== */

  const [
    profilePhoto,
    setProfilePhoto
  ] = useState(

    localStorage.getItem(
      "profile_photo"
    ) || ""

  );


  /* =====================================================
     FETCH PROFILE PHOTO
  ===================================================== */

  useEffect(() => {

    if (!email) {
      return;
    }


    const fetchProfile = async () => {

      try {

        const response =
          await axios.get(

            `/api/ignite/profile/${encodeURIComponent(
              email
            )}`

          );


        const photo =
          response.data?.user?.profilePhoto;


        if (photo) {

          setProfilePhoto(
            photo
          );

          localStorage.setItem(
            "profile_photo",
            photo
          );

        }

      }

      catch (err) {

        console.error(
          "Vision Navbar Profile Error:",
          err
        );

      }

    };


    fetchProfile();

  }, [email]);


  /* =====================================================
     PROFILE UPDATE EVENT

     Profile page-la photo update pannumbothu
     navbar automatically update aagum.
  ===================================================== */

  useEffect(() => {

    const handleProfileUpdate =
      (event) => {

        const photo =
          event.detail?.photo;


        if (photo) {

          setProfilePhoto(
            photo
          );

          localStorage.setItem(
            "profile_photo",
            photo
          );

        }

      };


    window.addEventListener(
      "profileUpdated",
      handleProfileUpdate
    );


    return () => {

      window.removeEventListener(
        "profileUpdated",
        handleProfileUpdate
      );

    };

  }, []);


  /* =====================================================
     LOGOUT
  ===================================================== */

  const handleLogout = () => {

    try {

      localStorage.removeItem(
        "user_email"
      );

      localStorage.removeItem(
        "user_level"
      );

      localStorage.removeItem(
        "profile_photo"
      );


      navigate(
        "/dashboard-login",
        {
          replace: true
        }
      );

    }

    catch (err) {

      console.error(
        "Logout Error:",
        err
      );

    }

  };


  /* =====================================================
     RENDER
  ===================================================== */

  return (

    <div className="vision-navbar">


      {/* =================================================
          LEFT
      ================================================= */}

      <div className="vision-navbar-left">


        {/* =================================================
            LOGO
        ================================================= */}

        <Link

          to="/measure"

          className="vision-logo"

        >

          VISION

          <span>
            IGNITE
          </span>

        </Link>


        {/* =================================================
            MEASURE - LEVEL 1
        ================================================= */}

        <Link

          to="/measure"

          className={

            active === "measure"

              ? "nav-link active"

              : "nav-link"

          }

        >

          <span>
            MEASURE
          </span>

          <small>
            LEVEL 1
          </small>

        </Link>


        {/* =================================================
            TRAIN - LEVEL 2
        ================================================= */}

        <Link

          to="/train"

          className={

            active === "train"

              ? "nav-link active"

              : "nav-link"

          }

        >

          <span>
            TRAIN
          </span>

          <small>
            LEVEL 2
          </small>

        </Link>


        {/* =================================================
            IMPROVE - LEVEL 3
        ================================================= */}

        <Link

          to="/improve"

          className={

            active === "improve"

              ? "nav-link active"

              : "nav-link"

          }

        >

          <span>
            IMPROVE
          </span>

          <small>
            LEVEL 3
          </small>

        </Link>


        {/* =================================================
            THRIVE - LEVEL 4
        ================================================= */}

        <Link

          to="/thrive"

          className={

            active === "thrive"

              ? "nav-link active"

              : "nav-link"

          }

        >

          <span>
            THRIVE
          </span>

          <small>
            LEVEL 4
          </small>

        </Link>


        {/* =================================================
            REPORT
        ================================================= */}

        <Link

          to="/vision-ignite/report"

          className={

            active === "report"

              ? "nav-link active report-link"

              : "nav-link report-link"

          }

        >

          <span>
            REPORT
          </span>

        </Link>


      </div>


      {/* =================================================
          RIGHT
      ================================================= */}

      <div className="vision-navbar-right">


        {/* =================================================
            PROFILE
        ================================================= */}

        <Link

          to="/profile"

          className="profile-avatar-small"

          title="Profile"

        >

          {

            profilePhoto

              ?

              (

                <img

                  src={profilePhoto}

                  alt="Profile"

                />

              )

              :

              (

                <FaUserCircle />

              )

          }

        </Link>


        {/* =================================================
            LOGOUT
        ================================================= */}

        <button

          type="button"

          className="nav-logout-btn"

          onClick={
            handleLogout
          }

          title="Logout"

        >

          <FaSignOutAlt />

          <span>
            LOGOUT
          </span>

        </button>


      </div>


    </div>

  );

};


export default VisionNavbar;